import React, { Component } from 'react';
import englishResources from 'wix-rich-content-common/dist/statics/viewer/locale/messages_en.json';
import { withI18n } from 'wix-rich-content-common';
import { R as RichContentViewer } from './getPluginViewers-8fee2600.js';
import 'prop-types';
import 'classnames';
import 'lodash';
import './utils/paywallSeo.js';
import './utils/draftUtils.js';
import 'punycode';
import './List-8e89c6a5.js';
import './utils/textUtils.js';
import './withInteraction.js';
import './utils/getInteractionWrapper.js';
import './utils/combineMappers.js';
import './components/Anchor.js';
import './components/ErrorBoundary.js';
import './inlineStyleMapper.js';
import 'wix-rich-content-common/libs/deprecateHelpers';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const WrappedViewer = withI18n(
  RichContentViewer,
  englishResources,
  { forceRemount: false }
);
class I18nRichContentViewer extends Component {
  render() {
    return /* @__PURE__ */ React.createElement(WrappedViewer, __spreadValues({}, this.props));
  }
}
I18nRichContentViewer.displayName = "RichContentViewer";

export { I18nRichContentViewer as default };
//# sourceMappingURL=I18nRichContentViewer.js.map
